













































































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";

//  @types
import { ExtendedVessel } from "@/types/vessel";
import { LongTrendDiagnosticType } from "@/types/longTrendDiagnosticType";

//  @clients
import LongTrendsClient from "Clients/long-trends-client";
//  @modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import SnackbarModule from "@/store/clients/Snackbar.module";

const Vessels = getModule(VesselsModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({})
export default class OverallVesselPerformanceStatus extends Vue {
  //  @Data
  longTrendsDiagnosticType: LongTrendDiagnosticType[] = [];
  isMenuOpen = false;

  //  @Getters
  get currentVessel(): ExtendedVessel | null {
    return Vessels.currentVessel;
  }

  get vesselPerformanceStatus(): string {
    if (!this.currentVessel || !this.currentVessel.performance) return "Unknown";
    if (this.currentVessel.performance.performanceStatus === "Ok") return "Okay";
    if (this.currentVessel.performance.performanceStatus === "NotOk") return "Not Okay";
    if (this.currentVessel.performance.performanceStatus === "BenchMarking") return "Benchmarking";
    return this.currentVessel.performance.performanceStatus ?? "Unknown";
  }

  get vesselPerformanceIcon(): string {
    if (!this.currentVessel || !this.currentVessel.performance) return "mdi-close-circle-outline";
    if (this.currentVessel.performance.performanceStatus === "Ok") return "$StatusOk";
    if (this.currentVessel.performance.performanceStatus === "Observe") return "$StatusObserve";
    if (this.currentVessel.performance.performanceStatus === "NotOk") return "$StatusNotOk";
    if (this.currentVessel.performance.performanceStatus === "BenchMarking") return "$StatusBenchmarking";
    return "mdi-close-circle-outline";
  }

  //  @Methods
  async fetchLongTrends(): Promise<void> {
    if (!this.currentVessel?.id) return Promise.reject();
    try {
      this.longTrendsDiagnosticType = await LongTrendsClient.findLongTrends(this.currentVessel.id);
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to load vessel long trends" });
    }
  }

  async onUseInVesselStatusChange(longTrendDiagnosticType: LongTrendDiagnosticType): Promise<void> {
    try {
      await LongTrendsClient.update(longTrendDiagnosticType);
      this.$emit("update");
      Snackbar.showSnackbar({ text: `${this.longTrendShortDescription(longTrendDiagnosticType)} parameter successfully updated`, color: "ContentPrimaryStatic" });
      //  Update the current vessel performance status in the store to reflect the changes made to the long trend diagnostic type
      if (!this.currentVessel) return Promise.reject();
      await Vessels.updateCurrentVesselById(this.currentVessel.id);
    } catch (error) {
      Snackbar.showSnackbar({ text: `Failed to update ${this.longTrendShortDescription(longTrendDiagnosticType)} parameter` });
    }
  }

  async onPrependSwitchClick(longTrendDiagnosticType: LongTrendDiagnosticType): Promise<void> {
    longTrendDiagnosticType.useInVesselStatus = !longTrendDiagnosticType.useInVesselStatus;
    await this.onUseInVesselStatusChange(longTrendDiagnosticType);
  }

  longTrendShortDescription(longTrendDiagnosticType: LongTrendDiagnosticType): string {
    return longTrendDiagnosticType.description.split(",")[0] ?? "";
  }

  parameterPerformanceIcon(longTrendDiagnosticType: LongTrendDiagnosticType): string {
    if (longTrendDiagnosticType.performanceStatus === "Ok") return "$StatusOk";
    if (longTrendDiagnosticType.performanceStatus === "Observe") return "$StatusObserve";
    if (longTrendDiagnosticType.performanceStatus === "NotOk") return "$StatusNotOk";
    if (longTrendDiagnosticType.performanceStatus === "BenchMarking") return "$StatusBenchmarking";
    return "mdi-close-circle-outline";
  }

  //  @Hooks
  async created(): Promise<void> {
    await this.fetchLongTrends();
  }
}
